module.exports = __webpack_public_path__ + "img/ic_foot_hight_11.aeea7912.png";